import React from 'react'
import { theme } from '../../../theme/theme'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { Icon, IconChoices } from '../../common/Icon'

interface PostPinnedProps {
  children?: React.ReactNode
}

export const PostPinned = ({ children }: PostPinnedProps): JSX.Element => {
  const { translate } = useAppTranslation()

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-2">
        <Icon
          icon={IconChoices.PIN}
          size={18}
          highlighted
          className="flex align-self-start"
        />
        <p
          className="uppercase"
          style={{
            ...theme.textVariants.captionBold,
            color: theme.colors.brandGreen,
          }}
        >
          {translate('post.pinned')}
        </p>
      </div>
      {children}
    </div>
  )
}
